import React from 'react';
import PolicyPage from './PolicyPage';

export default function PrivacyPolicy() {
  return (
    <PolicyPage title="Privacy Policy">
      <p className="text-sm text-secondary-500">Last updated: {new Date().toLocaleDateString('en-US')}</p>
      <p>
        Driscollland (“we”) respects your privacy. This policy describes how we collect, use, and protect your information when you use our website and services.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Information we collect</h2>
      <p>
        We may collect information you provide (name, email, phone, address) when you contact us, request services, or create an account. We also collect usage data to improve our site.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">How we use it</h2>
      <p>
        We use your information to provide lawn care and landscaping services, communicate with you, and improve our offerings. We do not sell your personal information to third parties.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Contact</h2>
      <p>
        For privacy questions, contact us at driscolledward@att.net.
      </p>
    </PolicyPage>
  );
}
